import api from './api';
import { Company, CompanyForm, CompanyList, CompanyUserInfo } from '../types';

export type { Company, CompanyForm, CompanyList, CompanyUserInfo } from '../types';

export const companiesApi = {
  // Получение списка компаний
  async getCompanies(search?: string): Promise<CompanyList[]> {
    const params = search ? { search } : {};
    const response = await api.get('/api/companies', { params });
    return response.data;
  },

  // Получение компании по ID
  async getCompany(id: number): Promise<Company> {
    const response = await api.get(`/api/companies/${id}`);
    return response.data;
  },

  // Создание компании
  async createCompany(companyData: CompanyForm): Promise<Company> {
    const response = await api.post('/api/companies', companyData);
    return response.data;
  },

  // Обновление компании
  async updateCompany(id: number, companyData: Partial<CompanyForm>): Promise<Company> {
    const response = await api.put(`/api/companies/${id}`, companyData);
    return response.data;
  },

  // Получение списка менеджеров
  async getManagers(): Promise<CompanyUserInfo[]> {
    const response = await api.get('/api/companies/users/managers');
    return response.data;
  },

  // Получение списка клиентов
  async getClients(): Promise<CompanyUserInfo[]> {
    const response = await api.get('/api/companies/users/clients');
    return response.data;
  },

  // Получение списка партнеров
  async getPartners(): Promise<CompanyUserInfo[]> {
    const response = await api.get('/api/companies/users/partners');
    return response.data;
  },

  // Получение списка CSM
  async getCSMs(): Promise<CompanyUserInfo[]> {
    const response = await api.get('/api/companies/users/csms');
    return response.data;
  },

};

